import { makeStyles } from '@material-ui/core';

import { ALIGNS } from './constants';

export default makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
  },
  border: {
    borderBottom: '1px solid lightgray',
    width: '100%',
  },
  content: {
    color: 'gray',
    fontFamily: 'roboto',
    fontSize: 15,
    fontWeight: 500,
    paddingBottom: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  },
  [ALIGNS.CENTER]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  [ALIGNS.LEFT]: {
    paddingRight: theme.spacing(2),
  },
  [ALIGNS.RIGHT]: {
    paddingLeft: theme.spacing(2),
  },
}));
